import { ca } from '@cian/analytics';

export function trackMortgageBrokerBannerShow() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Card',
    action: 'show_sopr',
    label: 'e2eMortgage_banner',
  });
}

export function trackMortgageBrokerBannerClick() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Card',
    action: 'Click',
    label: 'e2eMortgage_banner',
  });
}
